import React, { useContext, useMemo } from "react";
import { EditorContext, ModalServiceContext, RicosContext } from "./../../ricos-context";
import { AppEmbedData_AppType } from "./../../ricos-schema/legacy/wix/rich_content/v1";
import { VerticalEmbedInsertModal } from "../toolbar/VerticalEmbedInsertModal";
import { VERTICAL_EMBED_TYPE } from "../types";
const InsertModal = ({
  componentData,
  verticalsApi,
  nodeId,
  modalId
}) => {
  const { locale } = useContext(RicosContext);
  const { getEditorCommands } = useContext(EditorContext);
  const modalService = useContext(ModalServiceContext) || {};
  const closeModal = () => {
    modalService.closeModal(modalId);
  };
  const onConfirm = (verticalEmbed) => {
    const editorCommands = getEditorCommands();
    setTimeout(
      () => nodeId ? editorCommands?.setBlock(nodeId, VERTICAL_EMBED_TYPE, verticalEmbed) : editorCommands?.insertBlockWithBlankLines(VERTICAL_EMBED_TYPE, verticalEmbed),
      50
    );
    closeModal();
  };
  const verticalApi = useMemo(() => {
    if (verticalsApi && isTypeAppEmbed(componentData.type)) {
      return verticalsApi(getLowerCaseAppEmbedType(componentData.type), locale);
    }
  }, [verticalsApi, componentData.type, locale]);
  return verticalApi && componentData ? /* @__PURE__ */ React.createElement(
    VerticalEmbedInsertModal,
    {
      componentData,
      verticalApi,
      onConfirm,
      onCancel: closeModal
    }
  ) : null;
};
const isTypeAppEmbed = (type) => Object.values(AppEmbedData_AppType).includes(type);
const getLowerCaseAppEmbedType = (type) => type.toLowerCase();
export {
  InsertModal
};
//# sourceMappingURL=InsertModal.js.map
